import React, { useState } from 'react';
import { Typography } from '../Typography';
import { sizeTypography, variantTypography, colorTypography } from '../Typography/types';
import {
  TruncatedContainer,
  InfoIcon,
  TooltipContainer,
  TooltipText,
} from './styles';

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  size?: sizeTypography;
  colorText?: colorTypography;
  variant?: variantTypography;
  className?: string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength = 50,
  size = 'XS',
  colorText = 'black',
  variant = 'regular',
  className,
}) => {
  // Dos estados, no uno.
  //
  // 🔴 Con un solo `showTooltip` alternado por el clic, en TÁCTIL el aviso no
  // llegaba a verse: un toque dispara `mouseenter` sintético (que lo abría) y
  // acto seguido `click` (que lo cerraba), así que el dedo lo abría y lo
  // cerraba en el mismo gesto. En la tablet parecía que el icono no hacía
  // nada.
  //
  // Separando «fijado por pulsación» de «bajo el puntero»: el ratón lo asoma
  // al pasar por encima y la pulsación lo FIJA —en escritorio y en tablet
  // igual—, de modo que en escritorio no se cierra al apartar el ratón y en
  // tablet basta con tocar. Volver a pulsar lo cierra en los dos.
  const [isPinned, setIsPinned] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const showTooltip = isPinned || isHovered;
  const shouldTruncate = text && text.length > maxLength;
  const displayText = shouldTruncate
    ? `${text.substring(0, maxLength)}...`
    : text;

  if (!shouldTruncate) {
    return (
      <Typography
        size={size}
        colorText={colorText}
        variant={variant}
        className={className}
      >
        {text}
      </Typography>
    );
  }

  return (
    <TruncatedContainer className={className}>
      <Typography size={size} colorText={colorText} variant={variant}>
        {displayText}
      </Typography>
      <InfoIcon
        type="button"
        aria-expanded={showTooltip}
        aria-label={text}
        onClick={() => setIsPinned((pinned) => !pinned)}
        // `pointerenter` en vez de `mouseenter` para poder mirar de qué
        // puntero viene: el dedo emite los dos y sin el guard volvería el
        // abrir-y-cerrar del mismo toque.
        onPointerEnter={(event) => {
          if (event.pointerType === 'mouse') setIsHovered(true);
        }}
        onPointerLeave={(event) => {
          if (event.pointerType === 'mouse') setIsHovered(false);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape' && isPinned) setIsPinned(false);
        }}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle
            cx="7"
            cy="7"
            r="6"
            stroke="#666"
            strokeWidth="1"
            fill="#f0f0f0"
          />
          <path
            d="M7 3.5V4.5M7 6V10.5"
            stroke="#666"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <circle cx="7" cy="5" r="0.5" fill="#666" />
        </svg>
      </InfoIcon>
      {showTooltip && (
        <TooltipContainer>
          <TooltipText>{text}</TooltipText>
        </TooltipContainer>
      )}
    </TruncatedContainer>
  );
};
